import React from 'react';
import './index.css';
import TxtToSpeech from './txtTospeech.js';

export default function Education() {
  return (
    <div className="sectionComponent">
      <h1>EDUCATION</h1>
      <TxtToSpeech
        inputText={
          'Education. University of Southern California (Graduating December 2022). B.S. Neuroscience. Minor: Computer Programming. Specializations: Web Development, Cloud Computing with DevOps. Georgia Institute Technology (Graduating December 2025). M.S. Computer Science. Specialization: Computing Systems.  '
        }
      ></TxtToSpeech>
      <dl>
        <dt>University of Southern California (Grad. Dec 2022)</dt>
        <dd>B.S. Neuroscience</dd>
        <dd>Minor: Computer Programming</dd>
        <dd>Specializations: Web Development, Cloud Computing with DevOps</dd>
        <dt>Georgia Institute Technology (Grad. Dec 2025)</dt>
        <dd>M.S. Computer Science</dd>
        <dd>Specialization: Computing Systems</dd>
      </dl>
    </div>
  );
}
